export { default as reducer } from './credit.ducks';



// WEBPACK FOOTER //
// ./src/routes/Credit/index.ts